module.exports = __webpack_public_path__ + "img/home-card-item1.06be052f.png";